import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n.use(initReactI18next)
    .use(LanguageDetector)
    .use(HttpApi)
    .init({
        fallbackLng: 'ar',
        supportedLngs: ['ar', 'en'],
        detection: {
            order: ['cookie', 'querystring', 'localStorage', 'navigator', 'htmlTag'],
            caches: ['cookie'],
            lookupCookie: 'i18nextLng',
            lookupLocalStorage: 'i18nextLng',
        },
        backend: {
            loadPath: '/locales/{{lng}}/translation.json',
        },
        interpolation: { escapeValue: false },
        react: { useSuspense: false },
    });

i18n.changeLanguage('ar');
export default i18n;
